import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div<{ disabled?: boolean }>(
  ({ disabled, theme }) => `
  background: var(${
    disabled ? '--card-disabled-background-color' : '--card-background-color'
  });
  border-radius: var(--card-border-radius);
  box-shadow: 0 0 0 1px transparent;
  color: var(${disabled ? '--card-disabled-color' : '--card-color'});
  min-height: var(--card-min-height);
  margin: 1px;
  position: relative;
  transition: box-shadow 200ms ease;

  &::before {
    background: ${
      disabled
        ? 'var(--card-disabled-border-color)'
        : `linear-gradient(45deg, ${theme.palette.pink.medium} 0%, ${
            theme.palette.violet.medium
          } 100%)`
    };
    border-radius: calc(var(--card-border-radius) + 1px);
    content: '';
    position: absolute;
    inset: -1px;
    z-index: -1;
  }

  // Only on non-touch devices
  @media (hover: hover) and (pointer: fine) {
    &:not([disabled]):hover {
      box-shadow: 0 0 0 1px ${theme.palette.primary.main};
    }

    &:not([disabled]):focus-visible {
      outline-offset: -1px;
      outline: 2px solid ${theme.palette.primary.dark};
    }
  }

  @media (max-width: 768px) {
    --card-min-height: 64px;
  }

  @container main (max-width: 600px) {
    --card-min-height: 64px;
  }
`
);

const Icon = styled.figure`
  margin-right: ${rem(15)};
`;

const Content = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: ${rem(14)};
  font-weight: 500;
  line-height: ${rem(16)};
  padding: ${rem(16)};
  text-wrap: pretty;
  transition: color 200ms ease;
  width: 100%;
  height: 100%;

  // Only on non-touch devices
  @media (hover: hover) and (pointer: fine) {
    ${Wrapper}:not([disabled]):hover & {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

export default {
  Icon,
  Content,
  Wrapper
};
